<template>
    <div class="my-creations-container">
        <div class="my-creations-container__small-the-tools">
            <dashboard-ylands-icon
                class="my-creations-container__icon"
                style="height: 49px"
            ></dashboard-ylands-icon>
            <h4 class="my-creations-container__manage">MANAGE</h4>
        </div>
        <div class="my-creations-container__head">
            <h1 class="my-creations-container__title">My Creations</h1>
            <div class="my-creations-container__wrapper">
                <div class="my-creations-container__view-all-widget">
                <button-default
                    :color="'veryDarkBlue'"
                    :style="veryDarkBlueButton"
                    :link="MY_CREATIONS_PAGE_NAME"
                    :component-nav="true"
                    :svg="true"
                    :text="'View All'"
                    :name="'view_all_arrow'"
                    :svg-style="'width: 12px; fill: white; margin: auto 2px auto 6px;'"
                />
                </div>
                <div class="prev-nav-wrapper">
                      <div
                    slot="button-prev"
                    class="my-creations-container__swiper-button-prev button "
                    style="margin: auto 5px auto auto"
                >
                    <net-button
                        class="my-creations-container__net-button"
                    ></net-button>
                </div>
                <div
                    slot="button-next"
                    class="my-creations-container__swiper-button-next button "
                    style="margin: auto auto auto 5px"
                >
                    <net-button
                        class="my-creations-container__net-button"
                    ></net-button>
                </div>
                </div>
            </div>
        </div>
        <swiper
            v-if="allAssets.rows"
            :options="swiperOption"
            class="swiper-container"
        >
            <swiper-slide v-for="asset in allAssets.rows" :key="asset.id">
                <div class="swiper-container__card-wrapper">
                    <div class="swiper-container__card-image">
                        <assets-card
                            :key="asset.id"
                            :asset="asset"
                        ></assets-card>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <div v-else class="my-creations-container__no-data">No creations</div>
    </div>
</template>

<script>
import { MY_CREATIONS_PAGE_NAME } from '@/router/pageNameConstants.js';

import Button from '@/components/common/Button';
import NetButton from 'Svgs/netbutton_feat.svg?inline';
import DashboardYlandsIcon from 'Svgs/dashboard_ylands_ico.svg?inline';
import AssetsCard from '@/components/common/asset/AssetCard.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'MyCreations',
    components: {
        NetButton,
        AssetsCard,
        'button-default': Button,
        DashboardYlandsIcon,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            MY_CREATIONS_PAGE_NAME,
            author: null,
            assets: null,
            searchType: null,
            shownAssets: [],
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 20,
                allowTouchMove: true,
                autoHeight: true,
                breakpoints: {
                    992: {
                        slidesPerView: 'auto',
                        spaceBetween: 25,
                        centeredSlides: false,
                        initialSlide: 1,
                    },
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 25,
                        centeredSlides: true,
                        initialSlide: 1,
                    },
                    425: {
                        slidesPerView: 'auto',
                        spaceBetween: 15,
                        centeredSlides: true,
                        initialSlide: 1,
                    },
                    320: {
                        slidesPerView: 'auto',
                        spaceBetween: 10,
                        centeredSlides: true,
                        initialSlide: 1,
                        height: '300px',
                    },
                },
                navigation: {
                    nextEl: '.my-creations-container__swiper-button-next',
                    prevEl: '.my-creations-container__swiper-button-prev',
                },
            },
            veryDarkBlueButton: {
                backgroundColor: '#0a294a',
                border: '2px solid #0a294a',
                width: '94px',
                height: '29px',
                borderRadius: '6px',
                padding: '0',
                color: '$white-main',
                fontFamily: '$palanquin-font',
                fontSize: '13px',
                fontWeight: '400',
                letterSpacing: '0.05px',
            },
        };
    },
    computed: {
        order() {
            return {
                order_fields: ['released_at'],
                order_direction: ['osc'],
            };
        },
        ...mapGetters('all_assets', { allAssets: 'allAssets' }),
    },
};
</script>

<style scoped lang="scss">
.my-creations-container {
    display: grid;
    grid-template-rows: 0.8fr 0.7fr 8fr;
    width: auto;
    height: 465px;
    background: $white-main;
    padding-top: 0;
    @media (min-width: $sm-up) {
        padding-top: 4rem;
        //overflow: hidden;
    }
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        grid-template-rows: 0.8fr 0.7fr 8fr;
        padding-top: 4rem;
    }

    &__small-the-tools {
        display: grid;
        grid-template-columns: 1fr 1fr;
        height: 50px;
        width: 150px;
        margin: 3% auto auto 1rem;

        @media (max-width: $lg-up) {
            margin: 1rem auto 0 2rem;
        }
        @media (max-width: $xs-up) {
            display: none;
        }
    }
    &__icon {
        height: 49px;
    }
    &__manage {
        margin: 0 auto 0 3.5rem;
        width: 116px;
        height: 34px;
        color: $blue-main;
        font-family: $politica-font;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 1.03px;
        line-height: 53px;
        text-transform: uppercase;
    }

    &__head {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        width: 95%;
        margin-left: 1.5rem;
        margin-top: 1rem;
        align-items: self-end;
        @media (max-width: $lg-up) {
            grid-template-columns: 50% 50%;
        }
    }

    &__wrapper {
        display: flex;
        gap: 10px;
        flex-direction: row;
        width: fit-content;
        height: 44px;
    }

    &__title {
        display: block;
        grid-column: 1;
        grid-row: 1;
        margin-left: 1%;
        width: 308px;
        height: 44px;
        color: $blue-main;
        font-family: $istok-font;
        font-size: 36px;
        font-weight: 700;
        letter-spacing: 0.57px;
        line-height: 53px;
        margin: 0;
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            width: auto;
            height: 25px;
            font-size: 20px;
            letter-spacing: 0.32px;
            line-height: 25px;
        }
    }
    &__view-all-widget, .prev-nav-wrapper  {
        width: fit-content;
        display: flex;
        justify-content: center;
        align-items: center;    
    }
    &__swiper-navigation {
        grid-row: 2;
        justify-self: right;
        justify-items: center;
        width: 66px;
        height: 31px;
        @media (min-width: $sm-up) and(max-width: $md-up) {
            display: none;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            display: none;
            overflow: hidden;
        }
    }

    &__swiper-button-prev {
        grid-column: 3 / 4;
        height: 29px;
        width: 29px;
        transform: rotate(180deg);
        justify-self: right;

        &:hover,
        &:focus {
            svg {
                fill: lighten(#fa9f2a, 15%);
            }
        }

        @media (max-width: $lg-up) {
            display: none;
        }
    }

    &__swiper-button-next {
        grid-column: 4 / 5;
        height: 29px;
        width: 29px;

        &:hover,
        &:focus {
            svg {
                fill: lighten(#fa9f2a, 15%);
            }
        }
        @media (max-width: $lg-up) {
            display: none;
        }
    }
    &__net-button {
        @media (min-width: $sm-up) and(max-width: $md-up) {
            display: none;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            display: none;
            overflow: hidden;
        }
    }
    &__no-data {
        position: relative;
        height: 22rem;
        grid-row: 3;
        justify-self: center;
        align-self: center;
        color: $blue-main;
        font-family: $politica-font;
        font-size: 34px;
        font-weight: 700;
        letter-spacing: 0.88px;
        line-height: 51px;
    }
}
.swiper-container {
    position: relative;
    width: 95%;
    height: 22rem;
    grid-row: 3;
    margin: 2rem auto auto 1.5rem;
    padding: 0 27px 27px 0;
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        margin: 2rem auto auto 0.5rem;
    }

    .swiper-slide {
        min-width: 415px;
        min-height: 229px;
        width: auto;
        height: auto;
    }

    &__card-wrapper {
        position: relative;
        background-color: white;
        max-width: 415px;
        max-height: 229px;
        border-radius: 10px;
    }
    &__card-image {
        position: relative;
        max-width: 415px;
        max-height: 229px;
        min-width: 320px;
        min-height: 229px;
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            width: 395px;
        }
    }
}
.button {
    text-transform: capitalize;
}
</style>
